import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ft-one-col-block',
  templateUrl: './one-col-block.component.html',
})
export class OneColBlockComponent implements OnInit {
  @Input() page;

  @Input() contentBlock;

  /**
   * On Init
   */
  ngOnInit(): void {}
}
